import { Repository } from "../components/repository/repository"

export const RepositoryPage = () => {
    return (
        <Repository />
    )
}